<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .toast-msg {
        text-align: center;
        color: #666;
        padding: 10px 0 20px;
        font-weight: 300;
    }

    .toast-btn {
        display: inline-block;
        background: #fff;
        line-height: 40px;
        font-size: 16px;
        border-top: 1px solid #eee;
        color: #333;
        font-weight: 400;
        cursor: pointer;
    }


    .password-box {
        position: relative;
        width: 100%;
        height: 90px;
        max-width: 320px;
        margin: 0 auto;
        border-bottom: 1px solid #dfdfdf;
    }

    .toast-del {
        position: absolute;
        right: 5px;
        top: 5px;
        color: #666;
    }

    .toast-del:after{
        content: "";
        display: inline-block;
        width: 20px;
        height: 20px;
        /*background: url('../../assets/img/order/X.png') no-repeat;*/
        background-size: 100%;
    }

    .password-box span:first-child {
        border-left: 1px solid #dfdfdf;
    }
    .password-box span {
        display: block;
        border: 1px solid #dfdfdf;
        height: 50px;
        border-left: none;
        padding-right: 0;
        width: 16.5%;
        line-height: 50px;
        color: #000;
    }

    .password-input-box {
        position: absolute;
        width: 100%;
        height: 60px;
        left: 0;
        top: 0;
    }

    .password-box input {
        width: 110%;
        height: 50px;
        line-height: 30px;
        background: none;
        color: rgba(255, 255, 255, 0);
        border: none;
        text-indent: 30px;
        letter-spacing: 26px;
    }

    .toast-bg {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }

    .toast-body {
        max-width: 80%;
        overflow: hidden;
        margin: 0 auto;
        text-align: center;
    }
    .white-bg{
        position: relative;
    }
</style>
<template>
    <section class="toast-bg" v-show="status" @click.self="toCancel">
        <div class="toast-body" :style="{'margin-top':top}">
            <div class="white-bg border-radius-10">
                <i class="toast-del" @click="toCancel"></i>
                <h4 class="text-center toast-msg">请输入您的支付密码</h4>
                <div class="password-box">
                    <p class="text-center box" style="margin:0 10px">
                        <span v-for="(index,item) in num"><i v-if="password.length > (index-1)">*</i></span>
                    </p>
                    <div class="password-input-box">
                        <input type="password" v-model="password" maxlength="6" readonlyunselectable="on">
                    </div>
                    <p style="line-height: 40px;padding-right: 10px" class="text-right">
                        <a v-link="" class="min-text blue">忘记密码</a>
                    </p>
                </div>
                <div class="toast-btn blue password-box-btn" @click="submit"><span>确定</span></div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                num:6,
                password:''
            }
        },
        props: ['code', 'type', 'status', 'content', 'top','events'],
        methods: {
            toCancel: function () {
                this.$parent.$emit('cancel' + this.code);
            },
            submit: function () {
                let _this = this;
                if(this.password.length == 6) {
                    this.$parent.$emit('passwordPay' + this.code, [_this.password]);
                    this.password = '';
                } else {
                   site.toast(_this.$parent,'toasts','请输入6位密码')
                }
            }
        },
        components: {},
        mounted() {
            this.$nextTick(function () {

            })
        },
        created() {
            let _this = this,params = []
            let parent = _this.$parent,events = parent[_this.events],code = _this.code
            parent.$on('passwordPay'+_this.code,(w = []) => {
                params = (events&&events.confirmParam?[events.confirmParam].concat(w):w)
                parent.toasts[code] = false;
                if(events && events.submit && site._checkFun(parent[events.submit]))
                    parent[events.submit].apply(this,[params])
            })
            parent.$on('cancel'+code,(w) => {
                parent.toasts[code] = false;
                params = (events&&events.cancelParam?[events.cancelParam].concat(w):w)
                if(events && events.cancel && _this._checkFun(parent[events.cancel]))
                    parent[events.cancel].apply(this,[params])
            })
        }
    }
</script>


// WEBPACK FOOTER //
// passwords.vue?560a16a2